import { render, staticRenderFns } from "./key-value.vue?vue&type=template&id=4b24536d&"
import script from "./key-value.vue?vue&type=script&lang=js&"
export * from "./key-value.vue?vue&type=script&lang=js&"
import style0 from "./key-value.vue?vue&type=style&index=0&id=4b24536d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports